import { required } from '@rxweb/reactive-form-validators';

export class permissionsModel {
    @required()
    name: string;

    @required()
    guard_name: string;

}
